import { Divider, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { Fragment } from 'react';

const ContributorLoadingCell = ({
  showLeftBorder,
  showRightBorder,
  showXBorder,
}: {
  showLeftBorder?: boolean;
  showRightBorder?: boolean;
  showXBorder?: boolean;
}) => {
  return (
    <>
      <Flex
        p={4}
        bg="white"
        minH="184px"
        borderLeft={
          showLeftBorder || showXBorder ? '1px solid #E0E0E0' : 'none'
        }
        borderRight={
          showRightBorder || showXBorder ? '1px solid #E0E0E0' : 'none'
        }
      >
        <SkeletonCircle size="6" mr={3} />
        <Flex direction="column" gap={1} flex={1}>
          <Skeleton height="20px" width="120px" mb={1} />
          <Skeleton height="16px" width="80px" mb={1} />
          <Skeleton height="16px" width="180px" />
        </Flex>
        <SkeletonCircle size="4" mt={'auto'} />
      </Flex>
      <Divider />
    </>
  );
};

export default ContributorLoadingCell;
